import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import { toast } from 'sonner';
import { Mail, Phone, MapPin, Clock, Send } from 'lucide-react';
import emailjs from '@emailjs/browser';
const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleServiceChange = (value) => {
    setFormData({
      ...formData,
      service: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      toast.error('Please fill in all required fields');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          service_id: "service_b5o1lco",
          template_id: "template_ts7gz2w",
          user_id: "F9N2lVg8brQHdhkv1",
          template_params: {
            name: formData.name,
            from_name: formData.name,
            email: formData.email,
            from_email: formData.email,
            phone: formData.phone,
            company: formData.company || 'Not Provided',
            service: formData.service || 'Not Specified',
            message: "Name: " + formData.name + "\n" + "Phone: " + formData.phone + "\n" + "Company: " + formData.company + "\n" + "Service: " + formData.service + "\n" + "Message: " + formData.message,
            to_name: "Ozone Services"
          },
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to send message. Response status: " + response.status);
      }

      toast.success("Message sent successfully!");
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
      });
    } catch (error) {
      console.error("FAILED to send message via EmailJS REST API", error);
      toast.error("Something went wrong! Please check EmailJS Dashboard Settings.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="container mx-auto">
          <div className="text-center max-w-4xl mx-auto">
            <Badge className="bg-[#1C4BB6]/10 text-[#1C4BB6] mb-4">Contact Us</Badge>
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Get in Touch With Us
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              We are ready to support your facility management and manpower requirements with structured, reliable, and compliant solutions.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="grid lg:grid-cols-5 gap-12">
            {/* Contact Information - Left Side */}
            <div className="lg:col-span-2 space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
                <p className="text-gray-600 mb-8">
                  Reach out to us for any inquiries or service requests. Our team is here to help you.
                </p>
              </div>

              {/* Contact Cards */}
              <div className="space-y-4">
                <Card className="border-l-4 border-l-[#1C4BB6] shadow-md hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-[#1C4BB6]/10 p-3 rounded-full flex-shrink-0">
                        <MapPin className="text-[#1C4BB6]" size={24} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-2">Head Office</h3>
                        <p className="text-gray-600 text-sm leading-relaxed">
                          P-16, Sector Platinum, Shree Ram Square<br />
                          Near Angel Public School, Kalindi Gold City<br />
                          Indore, Madhya Pradesh – 452001
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card className="border-l-4 border-l-[#1C4BB6] shadow-md hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-[#1C4BB6]/10 p-3 rounded-full flex-shrink-0">
                        <Phone className="text-[#1C4BB6]" size={24} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-2">Phone Numbers</h3>
                        <p className="text-gray-600 text-sm">+91 9993892419</p>
                        <p className="text-gray-600 text-sm">+91 7724937376</p>

                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card className="border-l-4 border-l-[#1C4BB6] shadow-md hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-[#1C4BB6]/10 p-3 rounded-full flex-shrink-0">
                        <Mail className="text-[#1C4BB6]" size={24} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-2">Email Address</h3>
                        <p className="text-gray-600 text-sm">facility@ozoneservices.in</p>
                        <p className="text-gray-600 text-sm">operations@ozoneservices.in</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card className="border-l-4 border-l-[#1C4BB6] shadow-md hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="bg-[#1C4BB6]/10 p-3 rounded-full flex-shrink-0">
                        <Clock className="text-[#1C4BB6]" size={24} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 mb-2">Business Hours</h3>
                        <p className="text-gray-600 text-sm">Monday – Saturday</p>
                        <p className="text-gray-600 text-sm">9:00 AM – 6:30 PM</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>

            {/* Contact Form - Right Side */}
            <div className="lg:col-span-3">
              <Card className="border-0 shadow-xl">
                <CardContent className="p-8">
                  <h2 className="text-3xl font-bold text-gray-900 mb-2">Send Us a Message</h2>
                  <p className="text-gray-600 mb-8">
                    Fill out the form below and we'll get back to you within 24 hours.
                  </p>

                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <Label htmlFor="name">Full Name *</Label>
                        <Input
                          id="name"
                          name="name"
                          type="text"
                          placeholder="John Doe"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          className="border-gray-300 focus:border-[#1C4BB6] focus:ring-[#1C4BB6]"
                        />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="email">Email Address *</Label>
                        <Input
                          id="email"
                          name="email"
                          type="email"
                          placeholder="john@example.com"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          className="border-gray-300 focus:border-[#1C4BB6] focus:ring-[#1C4BB6]"
                        />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="space-y-2">
                        <Label htmlFor="phone">Phone Number *</Label>
                        <Input
                          id="phone"
                          name="phone"
                          type="tel"
                          placeholder="+91 98765 43210"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          className="border-gray-300 focus:border-[#1C4BB6] focus:ring-[#1C4BB6]"
                        />
                      </div>

                      <div className="space-y-2">
                        <Label htmlFor="company">Company Name</Label>
                        <Input
                          id="company"
                          name="company"
                          type="text"
                          placeholder="Your Company"
                          value={formData.company}
                          onChange={handleChange}
                          className="border-gray-300 focus:border-[#1C4BB6] focus:ring-[#1C4BB6]"
                        />
                      </div>
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="service">Service Interested In</Label>
                      <Select onValueChange={handleServiceChange} value={formData.service}>
                        <SelectTrigger className="border-gray-300 focus:border-[#1C4BB6] focus:ring-[#1C4BB6]">
                          <SelectValue placeholder="Select a service" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="soft-services">Soft Services / Housekeeping</SelectItem>
                          <SelectItem value="engineering">Engineering Services</SelectItem>
                          <SelectItem value="security">Security & Safety</SelectItem>
                          <SelectItem value="maintenance">Maintenance & Repair</SelectItem>
                          <SelectItem value="staffing">Staffing Solutions</SelectItem>
                          <SelectItem value="integrated">Integrated Facility Management</SelectItem>
                          <SelectItem value="other">Other</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>

                    <div className="space-y-2">
                      <Label htmlFor="message">Your Message *</Label>
                      <Textarea
                        id="message"
                        name="message"
                        placeholder="Tell us about your requirements..."
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows={5}
                        className="border-gray-300 focus:border-[#1C4BB6] focus:ring-[#1C4BB6]"
                      />
                    </div>

                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-[#1C4BB6] hover:bg-[#154096] text-white py-6 text-lg transition-all duration-300 hover:shadow-lg"
                    >
                      {isSubmitting ? 'Sending...' : (
                        <>
                          Send Message <Send className="ml-2" size={18} />
                        </>
                      )}
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Find Us Here</h2>
            <p className="text-gray-600">Visit our office during business hours</p>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.4894427685744!2d75.89243!3d22.75644!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDQ1JzIzLjIiTiA3NcKwNTMnMzIuNyJF!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ozone A-1 Services Location"
            ></iframe>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-[#1C4BB6] text-white">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-4xl font-bold mb-6">Let's Build Operational Excellence Together</h2>
          <p className="text-xl text-blue-100 mb-8">
            Whether you require long-term AMC contracts, professional housekeeping, engineering support, or structured manpower deployment — Ozone A-1 Services is your reliable facility partner.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            <a href="mailto:operations@ozoneservices.in">
              <Button variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-[#1C4BB6] px-8 py-6 text-lg transition-all duration-300">
                <Mail className="mr-2" size={20} /> Email Us
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
